


























































































































































import gql from '../gqlService.coffee'
import Fuse from 'fuse.js'
import DropDown from '@/components/DropDown.vue'
import settings from '../settings.coffee'
import queries from "@/gql/queries.coffee"
import mutations from "@/gql/mutations.coffee"

reviewHeight = 117

export default {
    "name": 'ReviewList',
    "components": {DropDown},
    "props": {
        "consultant_uid": String
        "establishment_uid": String
        "height": String
        "autoload": false
        "filters": { 
            "type": Object,
            "default": ()->
                return {
                    "positive": false
                    "search_string": ""
                    "classified": false
                    "establishment": {"name": null, "uid": null}
                    "sentiment": null
                    "status": null
                }
        }
        "consultant": null
    },
    "computed":
        style: ()->
            return {
                "height": this.height
            }
        filtered_review_set: ()->
            vm = @
            result = vm.review_set.results.map
            if vm.filters.search_string != ""
                fuse = new Fuse(vm.review_set.results, {
                    keys:[
                        {name: "text_fr", "weight": 1.0},
                        {name: "title_fr", "weight": 1.0},
                        {name: "title_native", "weight": 0.5},
                        {name: "author", "weight": 0.7},
                        {name: "establishment.name", "weight": 0.3},
                        {name: "platform.name", "weight": 0.3},
                    ]
                    minMatchCharLength: 5
                    distance: 2000
                    threshold: 0.4
                    isCaseSensitive: false
                })
                result = fuse.search(vm.filters.search_string)
            else
                result = vm.review_set.results
            
            ret = {
                results: result.reduce((acc, el)->
                    #if vm.filters.positive == el.positive
                    if el.task_status != null
                        if el.task_status.includes(',')
                            el.task_uid = el.task_status.split(',')[0];
                            el.task_status = el.task_status.split(',')[1];
                        else
                            el.task_uid = el.task_uid
                            el.task_status = el.task_status
                            
                    acc.push(el)
                    return acc
                ,[])
            }

            ret.results.sort((a, b)->
                comp = 1
                if a.published_on > b.published_on
                    comp = -1
                else if a.published_on == b.published_on
                    comp = 0
                return comp
            )

            ret["totalCount"] = ret.results.length
            return ret
        canGenerateResponses: ->
            if @filters.sentiment? and @filters.status?
                return (@filters.sentiment.value  and @filters.status.value == "New")
            else 
                return false
        
    "methods":
        "get_tag_name": (tag)->
        
            ret = null
            if tag?
                ret = this.$store.state.tag_name[tag.toLowerCase()]
            return ret

        "keydown": (e)->
            if e.target.tagName != "TEXTAREA"
                switch e.keyCode
                    when 40 then e.preventDefault();
                    when 38 then e.preventDefault();
        "keyup": (e)->
            vm = this
            if e.target.tagName != "TEXTAREA"
                switch e.keyCode
                    when 40 then vm.next();
                    when 38 then vm.prev();
        "next": (e)->
            self = this;
            index = 0
            for r in self.filtered_review_set.results
                if r.uid == self.$store.state.selected_review_uid
                    break
                index += 1
            if index+1 < self.filtered_review_set.results.length
                self.select(self.filtered_review_set.results[index + 1].uid)
            visible_objects = Math.floor(self.$refs['list'].offsetHeight / reviewHeight)
            to_scroll = index*reviewHeight - (visible_objects-2)*reviewHeight
            if to_scroll > 0
                self.$refs['list'].scroll(0,to_scroll)
            
        "prev": ()->
            self = this;
            index = 0
            for r in self.filtered_review_set.results
                if r.uid == self.$store.state.selected_review_uid
                    break
                index += 1
            if index-1 >= 0
                self.select(self.filtered_review_set.results[index - 1].uid)
            visible_objects = Math.floor((self.$refs['list'].scrollTop) / reviewHeight)
            scrolled = self.$refs['list'].scrollTop
            to_scroll = index*reviewHeight - (visible_objects+2)*reviewHeight
            if to_scroll < 0
                self.$refs['list'].scroll(0,self.$refs['list'].scrollTop+to_scroll)

        "select": (uid)->
            this.$router.push({"name": "flow_detail", "params": {'uid': uid}})
            
        "debug": ()->
            vm = @
            setTimeout( ()->
                vm.debug()
            , 1000)
        "get_class": (state_name)->
            return ['state-'+state_name.toLowerCase()]
        "build_filters": ()->
            filters =
                "establishment__consultant__uid":this.consultant_uid
                "establishment__active": true
            if not @filters.classified
                filters["current_state__class_name__neq"] = "Classified"
            if @filters.establishment.uid?
                filters["establishment"] = @filters.establishment.uid
            if @filters.platform.uid?
                filters["platform"] = @filters.platform.uid
            if @filters.sentiment.value?
                filters["positive"] = @filters.sentiment.value
            if @filters.status.value?
                filters["current_state__class_name"] = @filters.status.value
            if @filters.dateEnd?
                filters["published_on__lte"] = @filters.dateEnd
            if @filters.dateBegin?
                filters["published_on__gte"] = @filters.dateBegin
            if @filters.tag? and @filters.tag.name != null
                filters["current_state__tag__iexact"] = @filters.tag.code
            return filters
        
        "batch_reviews_generate_logos_answer": () ->
            review_ids = @filtered_review_set.results.map((review) => review.uid)
            await mutations.run("batch_reviews_generate_logos_answer", [review_ids])

        updateTaskStatus: (updatedTask)->
            index = @review_set.results.findIndex (review) -> review.uid == updatedTask.object_id
        
            if index != -1
                this.$set(@review_set.results, index, {
                    ...@review_set.results[index],
                    task_status: updatedTask.status,
                    task_uid:updatedTask.uid
                })
                
            
        "listenToTaskUpdates": ->
            @$djangows['onmodelsignals']({"modelName": "task", "appLabel": "core"}, (event)=>
                    @updateTaskStatus(event.obj);           
                )
        "getStatusTitle": (status) ->
            switch status
                when 'PENDING' then 'En attente de génération'
                when 'SUCCESS' then 'Génération effectuée'
                when 'FAILED' then 'Échec de la génération'
                when 'IN_PROGRESS' then 'Génération en cours'
                else 'Statut inconnu'
        getTaskUrl: (taskUid) ->
            return settings.backendUrl+"/admin/core/task/"+taskUid
    "data": ()->
        return {
            "loading": true
            "review_set": new gql.DataHolder({
                "model": "review_set",
                "fields": "uid title_fr title_native text_fr author positive mark published_on establishment {uid name custom_text_1} platform {name} positive current_state {verbose_name class_name tag} task_status"
                "autoload": this.autoload,
                "filters": "establishment__consultant__uid:\"#{this.consultant_uid}\", current_state__class_name__neq:\"Classified\", establishment__active: true",
                "reload_on_models": ["state_set"]
            })
            "backendUrl": settings.backendMediaUrl
        }
    "mounted": ()->
        vm = @
        this.review_set.promise.then ()->
            vm.loading = false
            
        window.addEventListener("keydown", vm.keydown, false)
        window.addEventListener("keyup", vm.keyup, false)

        if vm.$route.params.uid?
            this.$store.commit('select_review', vm.$route.params.uid)
        
        @$refs.searchBox.focus()

    "created": ->
            @listenToTaskUpdates()
      
    "beforeDestroy": ()->
        vm = this
        window.removeEventListener("keydown", vm.keydown)
        window.removeEventListener("keyup", vm.keyup)        
    "watch":
        "$store.state.selected_consultant_uid": (newV, oldV)->
            self = @
            self.loading = true
            if newV
                filters =
                    "establishment__consultant__uid":this.consultant_uid
                    "establishment__active": true
                if not @filters.classified
                    filters["current_state__class_name__neq"] = "Classified"
                self.review_set.query(filters).then ()->
                    self.loading = false
        "$route.params": (newV, oldV)->
            if newV.uid != oldV.uid
                this.$store.dispatch("select_review", newV.uid)
        "filters.sentiment": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.status": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.dateBegin": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.dateEnd": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.establishment.uid": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.platform.uid": (newV, oldV)->
            self = @
            @loading = true
            @review_set.query(@build_filters()).then ()->
                self.loading = false
        "filters.classified": (newV, oldV)->
            self = @
            if newV?
                self = @
                @loading = true
                @review_set.query(@build_filters()).then ()->
                    self.loading = false
        "filters.tag": (newV, oldV)->
            self = @
            if newV?
                self = @
                @loading = true
                @review_set.query(@build_filters()).then ()->
                    self.loading = false

        "$store.state.selected_review_uid": ()->
            @$refs.searchBox.focus()

}
